import { CommandIcon } from "lucide-react";

import { HotkeyDecorator } from "@/components/atoms/HotkeyDecorator";
import { State } from "@/state";
import { Button } from "@/components/ui/button";

/**
 * Quick actions, at the sidebar's head: a button, as wide as the sidebar, its
 * key at its end - and, the sidebar folded to its icons, its icon alone.
 */
export function AppSidebarCommandQuickActionsItem() {
  return (
    <Button
      variant="outline"
      size="sm"
      data-testid="sidebar-nav-commandCenter"
      aria-label="Quick actions"
      onClick={() => {
        State.getState().setCommandSearchValue("");
        State.getState().pushToCommandStack({
          commandDefinitionId: "search",
        });
      }}
      className="w-full justify-start [@container_(max-width:_50px)]:w-8 [@container_(max-width:_50px)]:justify-center [@container_(max-width:_50px)]:px-0"
    >
      <CommandIcon />
      <span className="truncate [@container_(max-width:_50px)]:hidden">
        Quick actions
      </span>
      {/* At its end; a touch screen, with no keys to press it with, shows
          none (``HotkeyDecorator``). */}
      <span className="ml-auto flex [@container_(max-width:_50px)]:hidden">
        <HotkeyDecorator
          hotkey={{ mac: "meta+k", windows: "ctrl+k", linux: "ctrl+k" }}
        />
      </span>
    </Button>
  );
}
